// Fix number to given fixNumber, or default 2 decimal points
export const fixNumber = ({ number, fixValue = 2 }: { number: number; fixValue?: number }): number => {
  return Number(number.toFixed(fixValue))
}
